// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductImage_wrapper__7jYP6","productImage":"ProductImage_productImage__XFarh"};